// extracted by mini-css-extract-plugin
export default {"wrapper":"GeneralInformation_wrapper__LubdA"};